/**
 * 企画回別商品一覧画面の企画回情報クラス
 *
 * @export CatalogInfo
 * @class CatalogInfo
 */
export class CatalogInfo {
  constructor(
    public previousCatalogId: string = '',
    public previousOrderCode: string = '',
    public previousCatalogFixFlg: string = '',
    public catalogId: string = '',
    public orderCode: string = '',
    public catalogFixFlg: string = '',
    public nextCatalogId: string = '',
    public nextOrderCode: string = '',
    public nextCatalogFixFlg: string = '',
  ) {}
}
